import React from "react"
import { useTranslation } from "react-i18next"
import { useLocation } from "react-router-dom"

import queryString from "query-string"
import styled from "styled-components/native"

import { AppLink } from "../app-link"
import { CallToDownloadApp } from "../call-to-download-app"
import Column from "../column"
import Modal from "../modal"
import TenantLogo from "../tenant-logo"
import Text from "../text"

const LOGO_MAX_WIDTH_PX = 128

const LOGO_MAX_HEIGHT_PX = 64

const Logo = styled(TenantLogo)`
  width: ${LOGO_MAX_WIDTH_PX}px;
  height: ${LOGO_MAX_HEIGHT_PX}px;
`

/**
 * Render a "Download the app" modal if we're on the /download route.
 *
 * NOTE: Our Caddy web server redirects to store pages if it can detect the
 * user's platform, so this is only shown when we're not sure where to send the
 * user.
 */
export function DownloadAppModal(): JSX.Element | null {
  const { t } = useTranslation()
  const location = useLocation()
  return (
    <Modal open={location.pathname === "/download"} maxWidth={340}>
      <Column
        gap="large"
        paddingTop="large"
        paddingBottom="xlarge"
        paddingHorizontal="large"
      >
        <Logo />
        <CallToDownloadApp queryParams={queryString.parse(location.search)} />
        <AppLink
          id="download-app"
          to={{ type: "path", path: "/" }}
          aria-label={t("Continue in your browser")}
        >
          <Text textStyle="button" color="accent">
            {t("Continue in your browser")}
          </Text>
        </AppLink>
      </Column>
    </Modal>
  )
}
